export function getDefaultSeed(playerIds: readonly string[]): number {
  const source = playerIds.join("|");
  let hash = 2166136261;
  for (let index = 0; index < source.length; index += 1) {
    hash ^= source.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function createRandom(seed: number): () => number {
  let value = seed >>> 0;
  return () => {
    value += 0x6d2b79f5;
    let next = value;
    next = Math.imul(next ^ (next >>> 15), next | 1);
    next ^= next + Math.imul(next ^ (next >>> 7), next | 61);
    return ((next ^ (next >>> 14)) >>> 0) / 4294967296;
  };
}

export function shuffle<T>(values: readonly T[], seed: number): readonly T[] {
  const next = [...values];
  const random = createRandom(seed);
  for (let index = next.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    const current = next[index];
    const target = next[swapIndex];
    if (current !== undefined && target !== undefined) {
      next[index] = target;
      next[swapIndex] = current;
    }
  }
  return next;
}

export function insertAtRandomIndex<T>(
  values: readonly T[],
  value: T,
  seed: number,
): readonly T[] {
  const random = createRandom(seed);
  const index = Math.floor(random() * (values.length + 1));
  return [...values.slice(0, index), value, ...values.slice(index)];
}
